const Resources = {

    table_headers: [
        { 
            name: '#',
        },
        { 
            name: 'Question',
        },
        { 
            name: 'Response',
        },
    ],

    table_headers_responses: 
    [
        { 
            text: 'Name',
            align: 'start',
            value: 'name',
          },
          { 
              text: 'Completed date',
              value: 'updated_at_formatted'
          },
          { 
              text: 'Responses',
              value: 'responses',
              type: 'link',
          },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'QC',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Surveys',
            href:   '/qc-surveys',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Surveys Test - Responses',
            href:   '#',
            arrow:  "",
        },
    ],

}

export default Resources;